<fieldset class="in-one-column">
  <legend class="ms-0">{{ title | translate }}:</legend>
  <ng-container [formGroup]="rootFormGroup.form">
    <ng-container [formArrayName]="formArrayName">
      <ng-container *ngIf="keyIsPhoneNumber">
        <mat-checkbox
          class="easy-checkbox"
          [disabled]="!basicData?.phone"
          (change)="useBasicDataPhone($event)"
        >
          {{ "MERCHANT.SITES.EDIT.USE_BASIC_PHONE" | translate }}
        </mat-checkbox>
      </ng-container>
      <div
        *ngFor="let keyValueFormGroup of formArray.controls; let i = index"
        [formGroup]="castToForm(keyValueFormGroup)"
        class="in-one-column with-delete-btn"
      >
        <div class="in-two-columns">
          <ng-container *ngIf="keyIsPhoneNumber; else keyIsNotPhoneNumber">
            <mat-form-field>
              <app-easy-phone-subform
                [formControlName]="keyControlName"
                [label]="keyControlTitle"
              ></app-easy-phone-subform>
            </mat-form-field>
          </ng-container>
          <ng-template #keyIsNotPhoneNumber>
            <mat-form-field *ngIf="!keyIsPhoneNumber">
              <app-easy-input
                [formControlName]="keyControlName"
                [label]="keyControlTitle | translate"
              >
              </app-easy-input>
            </mat-form-field>
          </ng-template>
          <app-easy-localized-value-subform
            [style.align-self]="keyIsNotPhoneNumber ? 'flex-end' : 'flex-end'"
            [title]="'SHARED.SHORT_DESCRIPTION'"
            [formGroupAbstract]="keyValueFormGroup.get(valueSubformGroupName)!"
          ></app-easy-localized-value-subform>
        </div>

        <!-- TODO Törlés gombnak itt sincs design -->

        <button
          type="button"
          mat-icon-button
          color="warn"
          (click)="onDelete(i)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </ng-container>
  </ng-container>
  <button
    class="w-100"
    type="button"
    mat-raised-button
    color="primary"
    (click)="onAdd()"
  >
    {{
      (keyIsPhoneNumber ? "MERCHANT.BTN.ADD_PHONE" : "MERCHANT.BTN.ADD_EMAIL")
        | translate
    }}
  </button>
</fieldset>
